import axios from 'axios';
const crmInput = (input = {}) => {
    if (typeof window === 'undefined' || !window.location.pathname.includes('/crm/board/')) return input;
    const shareToken = new URLSearchParams(window.location.search).get('shareToken');
    return shareToken && !input.shareToken ? { ...input, shareToken } : input;
};

const protocol = process.env.REACT_APP_DAILYPROFIT_BACKEND_PROTOCOL;
const url = process.env.REACT_APP_DAILYPROFIT_BACKEND_HOST;
const port = process.env.REACT_APP_DAILYPROFIT_BACKEND_PORT;
const crmBaseUrl = `${protocol}${url}${port}/landings`;

const checkForLanding = () => {

    return new Promise((resolve, reject) => {

        axios.get(`${protocol}${url}${port}/landings/checkForLanding`)
        .then(res => {
            resolve(res);
        })
        .catch(() => {
            console.error('CHECK FOR LANDING')
            resolve(false);
        })
    })
}

const editLanding = (dataa, file, fileLogo) => {

    let form = new window.FormData();

    let data = dataa;

    if (file) form.append('file', file);
    if (fileLogo) form.append('fileLogo', fileLogo);
    
    form.append('data', JSON.stringify(data));

    console.log('editLanding formm', form);
    return new Promise((resolve, reject) => {

        axios.post(`${protocol}${url}${port}/landings/editLanding`, form, {})
        .then(res => {
            resolve(res);
        })
        .catch(() => {
            console.error('EDIT LANDING')
            resolve(false);
        })
    })
}


const editLead = (lead) => {
    

    return new Promise((resolve, reject) => {

        axios.post(`${crmBaseUrl}/editLead`, crmInput(lead), {})
        .then(res => {
            resolve(res);
        })
        .catch(() => {
            console.error('EDIT LEAD')
            resolve(false);
        })
    })
}
const createLead = (lead) => {
    

    return new Promise((resolve, reject) => {

        axios.post(`${crmBaseUrl}/createLead`, crmInput(lead), {})
        .then(res => {
            resolve(res);
        })
        .catch(() => {
            console.error('EDIT LEAD')
            resolve(false);
        })
    })
}

const getMyLanding = (questId) => {

    return new Promise((resolve, reject) => {

        axios.get(`${protocol}${url}${port}/landings/getMyLanding?questId=${questId}`)
        .then(res => {
            resolve(res);
        })
        .catch(() => {
            console.error('GET MY LANDING')
            resolve(false);
        })
    })
}

const getMyLandings = () => {

    return new Promise((resolve, reject) => {

        axios.get(`${protocol}${url}${port}/landings/getMyLandings`)
        .then(res => {
            resolve(res);
        })
        .catch(() => {
            console.error('GET MY LANDINGS')
            resolve(false);
        })
    })
}

const getLandingById = (id) => {

    return new Promise((resolve, reject) => {

        axios.get(`${crmBaseUrl}/getLandingById`, { params: crmInput({ landingId: id }) })
        .then(res => {
            resolve(res);
        })
        .catch(() => {
            console.error('GET LANDING')
            resolve(false);
        })
    })
}

const submitForm = (data) => {
    return new Promise((resolve, reject) => {

        axios.post(`${protocol}${url}${port}/landings/submitForm`, {data: data}, {})
        .then(res => {
            resolve(res);
        })
        .catch(() => {
            console.error('SUBMIT FORM')
            resolve(false);
        })
    })
}

const cloneLanding = (id, facebookPageId) => {

    return new Promise((resolve, reject) => {

        axios.post(`${protocol}${url}${port}/landings/cloneLanding?landingId=${id}&facebookPageId=${facebookPageId}`, {}, {})
        .then(res => {
            resolve(res);
        })
        .catch(() => {
            console.error('CLONE LANDING')
            resolve(false);
        })
    })
}

const getPaginatedLeads = (questId, pageNo, numOfDocuments, startDate, endDate, callFilters = {}, source = 'all') => {

    return new Promise((resolve, reject) => {

        axios.post(`${crmBaseUrl}/getPaginatedLeads`, crmInput({
            questId,
            pageNo,
            numOfDocuments,
            startDate,
            endDate,
            source,
            callTiming: Array.isArray(callFilters?.timing) ? callFilters.timing.join(",") : callFilters?.timing || "all",
            callAssignee: Array.isArray(callFilters?.assignee) ? callFilters.assignee.join(",") : callFilters?.assignee || "all",
            callOutcome: Array.isArray(callFilters?.outcome) ? callFilters.outcome.join(",") : callFilters?.outcome || "all",
            timezoneOffset: new Date().getTimezoneOffset(),
        }), {})
        .then(res => {
            resolve(res);
        })
        .catch(() => {
            console.error('GET PREVIEW')
            resolve(false);
        })
    })
}


const editLeadsCrm = (dataa, file, fileLogo) => {

    let form = new window.FormData();

    let data = dataa;

    if (file) form.append('file', file);
    if (fileLogo) form.append('fileLogo', fileLogo);
    
    form.append('data', JSON.stringify(data));

    console.log('editLanding formm', form);
    return new Promise((resolve, reject) => {

        axios.post(`${crmBaseUrl}/editLeadsCrm`, form, {})
        .then(res => {
            resolve(res);
        })
        .catch(() => {
            console.error('EDIT LANDING')
            resolve(false);
        })
    })
}

const addNote = (leadId, text) => {
    
    return new Promise((resolve, reject) => {

        axios.post(`${crmBaseUrl}/addNote`, crmInput({leadId, text}))
        .then(res => {
            resolve(res);
        })
        .catch(() => {
            console.error('Add note')
            resolve(false);
        })
    })
}


const deleteNote = (leadId, noteId) => {
    
    return new Promise((resolve, reject) => {

        axios.post(`${crmBaseUrl}/deleteNote`, crmInput({leadId, noteId}))
        .then(res => {
            resolve(res);
        })
        .catch(() => {
            console.error('Delete note')
            resolve(false);
        })
    })
}


const editNote = (leadId, noteId, text) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${crmBaseUrl}/editNote`, crmInput({ leadId, noteId, text, }))
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        console.error("Edit note failed", err);
        resolve(false);
      });
  });
};



const archiveLead = (leadId) => {
  return new Promise((resolve, reject) => {
    axios.post(`${crmBaseUrl}/archiveLead`, crmInput({ leadId }))
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        console.error("Archive lead failed", err);
        resolve(false);
      });
  });
};

const archiveLeads = (leadIds = []) => {
  return Promise.allSettled(
    leadIds.map((leadId) => archiveLead(leadId))
  );
};


const getArchivedLeads = (params) => {
  return new Promise((resolve) => {
    axios
      .get(`${crmBaseUrl}/getArchivedLeads`, {
        params: crmInput(params),
      })
      .then(res => resolve(res))
      .catch(err => {
        console.error("Get archived leads failed", err);
        resolve(false);
      });
  });
};


const restoreLead = (leadId) => {
  return new Promise((resolve, reject) => {
    axios.post(`${crmBaseUrl}/restoreLead`, crmInput({ leadId }))
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        console.error("Restore lead failed", err);
        resolve(false);
      });
  });
};

const findMissingLeads = (questId, startDate, endDate) => {
  return new Promise((resolve) => {
    axios.post(`${crmBaseUrl}/findMissingLeads`, crmInput({ questId, startDate, endDate }))
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        console.error("Find missing leads failed", err);
        resolve(false);
      });
  });
};

const restoreMissingLeads = (questId, startDate, endDate) => {
  return new Promise((resolve) => {
    axios.post(`${crmBaseUrl}/restoreMissingLeads`, crmInput({ questId, startDate, endDate }))
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        console.error("Restore missing leads failed", err);
        resolve(false);
      });
  });
};

const deleteLead = (leadId) => {
  return new Promise((resolve, reject) => {
    axios.post(`${crmBaseUrl}/deleteLead`, crmInput({ leadId }))
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        console.error("Delete lead failed", err);
        resolve(false);
      });
  });
};

const deleteLeads = (leadIds = []) => {
  return Promise.allSettled(
    leadIds.map((leadId) => deleteLead(leadId))
  );
};


const detectDuplicates = (data) => {
  return new Promise((resolve) => {
    axios.post(`${crmBaseUrl}/detectDuplicates`, crmInput(data))
      .then(res => resolve(res))
      .catch(err => {
        console.error("Detect duplicates failed", err);
        resolve(false);
      });
  });
};

const importLeads = (data) => {
  return new Promise((resolve, reject) => {
    axios.post(`${crmBaseUrl}/importLeads`, crmInput(data))
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        console.error("Import leads failed", err);
        resolve(false);
      });
  });
};


const landingEndpoints = {
    checkForLanding,
    editLanding,
    editLead,
    createLead,
    editLeadsCrm,
    getMyLanding,
    getMyLandings,
    getLandingById,
    submitForm,
    cloneLanding,
    getPaginatedLeads,
    addNote,
    deleteNote,
    editNote,
    archiveLead,
    archiveLeads,
    getArchivedLeads,
    restoreLead,
    findMissingLeads,
    restoreMissingLeads,
    deleteLead,
    deleteLeads,
    importLeads,
    detectDuplicates
}

export default landingEndpoints;
